import type { ForqFeatureManifest, ForqModuleManifest } from '@forq/contracts';
import { EventBus } from './eventBus';
import { Registry } from './registry';

export interface ForqRuntime {
  readonly modules: Registry<ForqModuleManifest>;
  readonly features: Registry<ForqFeatureManifest>;
  readonly events: EventBus;
}

export function createForqRuntime(): ForqRuntime {
  return {
    modules: new Registry<ForqModuleManifest>(),
    features: new Registry<ForqFeatureManifest>(),
    events: new EventBus(),
  };
}
